// import Attendance from "./Attendance";

export default {
  // component: Attendance,
  priority: 97,
  name: app.translate("routes.home.attendance.modifier.Modifier"),
  path: "modifier",
  permissions: ["TimeAttendanceMenu/EditReportMenu"], // ["ReportsMenu", "DeviceListMenu", "DeviceChartMenu", "ClockingMenu", "WorkingHourMenu", "CalendarMenu"
  // ,"ShiftDefinitionMenu", "PositionsMenu", "WritMenu", "PolicyDefinitionMenu", "SettingDefinitionMenu", "StackRulesMenu", "StackHistoryMenu"],
  component: load(() => import(/* webpackChunkName: "Writs" */ "./Modifier")),
  icon: "av-timer",
  drawer: true,
};
